export default __webpack_public_path__ + "assets/ccrpp.ffb9462a.png";